import isVerifyTokenGuard from '@/guards/verifyTokenGuard'

export default {
  name: 'psychologist-payment-concepts-layout',
  component: () => import(/* webpackChunkName: "psychologist-payment-concepts" */ '@/layouts/PrincipalLayout.vue'),
  children: [
    {
      path: '',
      name: 'admin-psychologist-payment-concepts',
      beforeEnter: [isVerifyTokenGuard],
      meta: {
        breadcrumbs: [
          {
            transKey: 'breadcrumbs.admin-psychologist-payment-concepts',
            isActive: true,
          },
        ],
      },
      component: () => import(/* webpackChunkName: "admin-psychologist-payment-concepts" */ '@/modules/admin/psychologist-payment-concepts/views/Index.vue'),
    },
    {
      path: 'create',
      name: 'admin-psychologist-payment-concepts-create',
      beforeEnter: [isVerifyTokenGuard],
      meta: {
        breadcrumbs: [
          {
            route: {
              name: 'admin-psychologist-payment-concepts',
            },
            transKey: 'breadcrumbs.admin-psychologist-payment-concepts',
            isActive: false,
          },
          {
            transKey: 'breadcrumbs.admin-psychologist-payment-concepts-create',
            isActive: true,
          },
        ],
      },
      component: () => import(/* webpackChunkName: "admin-psychologist-payment-concepts-create" */ '@/modules/admin/psychologist-payment-concepts/views/Create.vue'),
    },
    {
      path: 'edit/:id',
      name: 'admin-psychologist-payment-concepts-edit',
      beforeEnter: [isVerifyTokenGuard],
      meta: {
        breadcrumbs: [
          {
            route: {
              name: 'admin-psychologist-payment-concepts',
            },
            transKey: 'breadcrumbs.admin-psychologist-payment-concepts',
            isActive: false,
          },
          {
            transKey: 'breadcrumbs.admin-psychologist-payment-concepts-edit',
            isActive: true,
          },
        ],
      },
      component: () => import(/* webpackChunkName: "admin-psychologist-payment-concepts-edit" */ '@/modules/admin/psychologist-payment-concepts/views/Create.vue'),
    },
    {
      path: 'view/:id',
      name: 'admin-psychologist-payment-concepts-view',
      beforeEnter: [isVerifyTokenGuard],
      meta: {
        breadcrumbs: [
          {
            route: {
              name: 'admin-psychologist-payment-concepts',
            },
            transKey: 'breadcrumbs.admin-psychologist-payment-concepts',
            isActive: false,
          },
          {
            transKey: 'breadcrumbs.admin-psychologist-payment-concepts-view',
            isActive: true,
          },
        ],
      },
      component: () => import(/* webpackChunkName: "admin-psychologist-payment-concepts-view" */ '@/modules/admin/psychologist-payment-concepts/views/Create.vue'),
    },
  ],
}
